// extracted by mini-css-extract-plugin
export default {"topNav":"UG-z","category":"VG-z","noArrow":"WG-z","alternative":"XG-z","topLevelNavItem":"YG-z","navContainer":"ZG-z","subcategoryHeading":"_G-z","subcategory":"aH-z"};